import React, { useEffect, useState } from "react";
import { Table, Button, message, Pagination, Tag } from "antd";
import { get, post } from "../../api/axios";
import { Link } from "react-router-dom";

const PlatformCoupons = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(1);
  const [changingStatusId, setChangingStatusId] = useState(null);

  const fetchData = (page = 1) => {
    setLoading(true);
    get(`makan-coupons?page=${page}`)
      .then((res) => {
        setData(res?.data?.data || []);
        setTotal(res?.data?.meta?.last_page || 1);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangeStatus = (couponId, newStatus) => {
    setChangingStatusId(couponId);
    post(`change-makan-coupon-status`, {
      coupon_id: couponId,
      status: newStatus,
    })
      .then(() => {
        message.success("تم تعديل الحالة بنجاح");
        setData((prev) =>
          prev.map((item) =>
            item.id === couponId
              ? { ...item, status: newStatus === 1 ? "ساري" : "منتهي" }
              : item,
          ),
        );
      })
      .catch(() => {
        message.error("حدث خطأ أثناء تعديل الحالة");
      })
      .finally(() => setChangingStatusId(null));
  };

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "الكود", dataIndex: "code" },
    { title: "عدد الأيام", dataIndex: "days" }, // ✅ جديد
    { title: "تاريخ البداية", dataIndex: "start_date" },
    { title: "تاريخ النهاية", dataIndex: "end_date" },

    {
      title: "الحالة",
      render: ({ status }) => (
        <Tag color={`${status == "منتهي" ? "error" : "success"}`}>{status}</Tag>
      ),
    },
    {
      title: "تغيير الحالة",
      render: (record) => {
        const isActive = record.status === "ساري";
        const isLoading = changingStatusId === record.id;

        return isActive ? (
          <Button
            danger
            size="small"
            loading={isLoading}
            onClick={() => handleChangeStatus(record.id, 2)}
          >
            إنهاء
          </Button>
        ) : (
          <Button
            type="primary"
            size="small"
            loading={isLoading}
            onClick={() => handleChangeStatus(record.id, 1)}
          >
            تفعيل
          </Button>
        );
      },
    },
    {
      title: "تعديل",
      dataIndex: "id",
      render: (id) => (
        <button className="btn btn-outline-warning btn-sm p-0">
          <Link
            to={`/platform-coupons/edit/${id}`}
            className="color-inherit text-decoration-none py-1 px-2 d-block"
          >
            تعديل
          </Link>
        </button>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="col-lg-4 offset-lg-4 mb-3">
        <Link to="/platform-coupons/add" className="text-decoration-none">
          <Button type="primary" block>
            إضافة كوبون
          </Button>
        </Link>
      </div>

      <div className="col-12">
        <Table
          rowKey="id"
          loading={loading}
          dataSource={data}
          columns={columns}
          pagination={false}
          scroll={{ y: "65vh" }}
        />

        <Pagination
          className="mt-4 d-flex justify-content-center"
          total={total * 10}
          onChange={(page) => fetchData(page)}
        />
      </div>
    </div>
  );
};

export default PlatformCoupons;
